import styled from 'styled-components';
import { ThemeColours } from '../../../../styles/ThemeColours';
import { Breakpoint, Orientation } from '../../../../styles/constants';

// As short as needed
export const SuggestionLayoutView = styled.div`
  background-color: ${ThemeColours.white};
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
  min-height: 300px;
  overflow-x: hidden;
  padding-bottom: 84px;

  ${Orientation.LANDSCAPE} {
    padding-bottom: 0;
  }

  ${Breakpoint.SMALL} {
    padding-bottom: 0;
  }
`;

// Fixed size
export const ButtonBarContainer = styled.div`
  flex-grow: 0;
  min-height: 40px;
`;

// Expands to fill its content, but caps off and shows a scrollbar
export const ListContainer = styled.div`
  flex: 1;
  overflow: auto;
  padding-bottom: 32px;
`;
